+function ($) {

	/* ===============================
	 * Javascript Events on Index Page
	 =============================== */
	'use strict';
	$(window).load( function () {

		// Global
		var show = 'show';

		/**
		 * Truck Animation
		 */

		var $window = $(window),
				$truck = $('#truck');

		var windowHeight,
				wrapperWidth,
				truckWidth,
				truckHeight,
				truckTop;

		var disappearPoint, appearPoint, gap;

		var currentPoint, truckPosition;

		function setVarialbes () {
			windowHeight = $window.height(),
			wrapperWidth = $truck.parent().width(),
			truckWidth = $truck.width(),
			truckHeight = $truck.height(),
			truckTop = $truck.offset().top;

			/*console.log('windowHeight: ' + windowHeight);
			console.log('wrapperWidth: ' + wrapperWidth);
			console.log('truckWidth: ' + truckWidth);
			console.log('truckHeight: ' + truckHeight);
			console.log('truckTop: ' + truckTop);*/

			disappearPoint = truckTop + truckHeight,
			appearPoint = truckTop - windowHeight;

			if (appearPoint < 0 ) appearPoint = 0

			gap = disappearPoint - appearPoint;

			// console.log('disappearPoint: ' + disappearPoint);
			// console.log('appearPoint: ' + appearPoint);

			return false;
		}

		function calTruckPosition () {
			return (wrapperWidth - truckWidth) * (1-((disappearPoint - currentPoint) / gap));
		}

		function scrollEvent ()  {
			currentPoint = $window.scrollTop();
			// console.log('currentPoint: ' + currentPoint);
			if ( currentPoint >= appearPoint && currentPoint <= disappearPoint) {
				truckPosition = calTruckPosition();
				$truck.css('left', truckPosition);

				if (currentPoint <= appearPoint )
					$truck.removeClass(show);
				else
					$truck.addClass(show);
			}
			return false;
		}

		setVarialbes();
		$window.scroll( scrollEvent );
		$window.resize( setVarialbes );

		/**
		 * Category
		 */
		var $categoryArea = $('.index-trucks-categories'),
				$categoryToggleBtn = $('.index-categories-toggle-button');

		$categoryToggleBtn.click(function (e) {
			// console.log('click');
			$categoryArea.toggleClass(show);
		});
	});
}(jQuery);